module.exports = __webpack_public_path__ + "img/1600.6d53bb76.jpg";